import { Box, Button, Container, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { WorkfoceHeader } from "./components/WorkforceHeader";
import { MetricsSection } from "./components/MetricsSection";
import { CallToAction } from "./components/CallToAction";
import { DetailedWorkforceOverview } from "./DetailedWorkforceOverview";
import { TimePeriod } from "../../clients/interfaces/TimePeriod.interface";
import { colors, alphaVar } from "../../ui/colors";
import { BaseModalComponent } from "../../common/BaseModalComponent";
import { ConnectBusinessAlgorithm } from "../../connectBusinessAlgorithm";
import { ConnectionRequests } from "../../connectionRequests";
import { ETimePeriods } from "../enums/timesheets.enum";
import TimeSheet from "../../time-sheet/TimeSheet";

export const WorkforceList = () => {
  const [timePeriod, setTimePeriod] = useState<ETimePeriods>(ETimePeriods.WEEKLY);
  const theme = useTheme();

  return (
    <Container maxWidth="xl" sx={{ py: 4, px: { xs: 1, sm: 2, md: 4 } }}>
      <WorkfoceHeader
        timePeriods={[
          { label: "W", value: ETimePeriods.WEEKLY },
          { label: "M", value: ETimePeriods.MONTHLY },
          { label: "Q", value: ETimePeriods.QUARTERLY },
          { label: "Y", value: ETimePeriods.YEARLY },
        ]}
        value={timePeriod}
        onSetTimePeriod={setTimePeriod}
      />

      <MetricsSection timePeriod={timePeriod} enableLabel={true} />
      <CallToAction
        content={
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <BaseModalComponent
              modalKey="View-Connections-Modal"
              modalLabel="Connections"
              elementTrigger={
                <Button
                  variant="text"
                  disableElevation
                  sx={{
                    color: theme.palette.text.secondary,
                    textTransform: "none",
                    fontWeight: 600,
                    borderRadius: "10px",
                    px: 3,
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: alphaVar(theme.palette.grey[100], 0.8),
                      color: colors.orange[400],
                    },
                  }}
                >
                  See my connections
                </Button>
              }
            >
              <ConnectionRequests sx={{}} />
            </BaseModalComponent>

            <BaseModalComponent
              modalKey="Organization-TimeSheets"
              modalLabel="Find an Expert"
              elementTrigger={
                <Button
                  variant="contained"
                  disableElevation
                  sx={{
                    backgroundColor: alphaVar(colors.orange[400], 0.1),
                    color: colors.orange[400],
                    textTransform: "none",
                    fontWeight: 700,
                    borderRadius: "10px",
                    px: 3,
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: alphaVar(colors.orange[400], 0.2),
                      boxShadow: "none",
                    },
                  }}
                >
                  Add a connection
                </Button>
              }
            >
              <ConnectBusinessAlgorithm />
            </BaseModalComponent>

            <BaseModalComponent
              modalKey="Add-Connection-Modal"
              modalLabel="Timesheets"
              elementTrigger={
                <Button
                  variant="contained"
                  disableElevation
                  sx={{
                    backgroundColor: alphaVar(colors.orange[400], 0.1),
                    color: colors.orange[400],
                    textTransform: "none",
                    fontWeight: 700,
                    borderRadius: "10px",
                    px: 3,
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: alphaVar(colors.orange[400], 0.2),
                      boxShadow: "none",
                    },
                  }}
                >
                  See Timesheets
                </Button>
              }
            >
              <TimeSheet />
            </BaseModalComponent>
          </Box>
        }
      />
      <DetailedWorkforceOverview />
    </Container>
  );
};
